import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';

const styles = theme => ({
  card: {
    flexDirection: window.innerWidth > 1500 ? 'row' : 'column',
  },

  statusCardContainer: {
    width: '50%',
  },

  cardStatus: {
    flex: 1,
    color: 'var(--jmi-blue)',
  },

  cardOrderCount: {
    flex: 1,
  },

  arcBarContainer: {
    overflow: 'hidden',
  },

  disableTouchEvents: {
    pointerEvents: 'none',
  },
});

export const OrderStatusCard = withRouter(
  withStyles(styles)(({ classes, statusInfo, disabled, history, onClick }) => {
    const { status, statusId, count, label, gridName } = statusInfo;
    let cardBorderClass = 'border-left-neutral';
    let arcBorderClass = 'border-neutral';
    let textColorClass = 'text-neutral';

    if (count) {
      if (status === 'Manual Field Rep Assignment Required') {
        cardBorderClass = 'border-left-red';
        arcBorderClass = 'border-red';
        textColorClass = 'text-red';
      } else {
        cardBorderClass = 'border-left-green';
        arcBorderClass = 'border-green';
        textColorClass = 'text-green';
      }
    }

    const _onClick = evt => {
      if (disabled) return;

      if (!!onClick) {
        onClick(evt);
      } else {
        history.push(`/orders/by-status?statusId=${statusId}&status=${status}&gridName=${gridName}`);
      }
    };

    const useColumnLayout = window.innerWidth <= 1500;

    return (
      <div className={classnames('order-status-card-container', classes.statusCardContainer)}>
        <div
          className={classnames(
            'order-status-card',
            'card',
            classes.card,
            cardBorderClass,
            useColumnLayout ? 'row-center-center' : 'column-between-center',
            (count === 0 || disabled) && classes.disableTouchEvents,
          )}
          onClick={_onClick}
        >
          <div className={classnames('row-center-center', classes.cardStatus)}>{label ? label : status}</div>
          <div className={classnames('row-center-center', classes.cardOrderCount)}>
            <div className={classes.arcBarContainer} style={{ marginTop: useColumnLayout ? 15 : 0 }}>
              <div className={classnames('arc-bar', arcBorderClass)}>
                <div className="arc-bar-square-blocker"></div>
                <span className={classnames(textColorClass)} style={{ fontSize: 16, fontWeight: 700, zIndex: 0 }}>
                  {count}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }),
);

OrderStatusCard.propTypes = {
  statusInfo: PropTypes.object.isRequired,
};

OrderStatusCard.defaultProps = {};
